import { getPrivacyPolicyUrl } from "@certn/utils";
import { useTranslation } from "react-i18next";

import { HelpAndPrivacyLinkItem } from "./HelpAndPrivacyLinkItem";

export function PrivacyPolicy() {
  const { t, i18n } = useTranslation();
  const privacyPolicyUrl = getPrivacyPolicyUrl(i18n.language);

  return (
    <HelpAndPrivacyLinkItem
      testID="help-and-privacy-privacy-policy-view-button"
      item={t("Privacy policy")}
      description={t("Learn about how we protect your privacy here")}
      linkText={t("View")}
      link={privacyPolicyUrl}
    />
  );
}
